"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Text_1 = require("ContentTokens/Models/Text");
var slate_react_1 = require("slate-react");
var EditorTypes_1 = require("./../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var TableActions = __importStar(require("./TableActions"));
var TableActionUtilities_1 = require("./TableActionUtilities");
var Models_1 = require("ContentTokens/Models");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var WidgetActions = __importStar(require("./WidgetActions"));
exports.default = (function (di) {
    var blockType = di.get("blockStore").blockType;
    var editorTelemetry = di.get("editorTelemetry");
    return {
        onTableAdd: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("addTable")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "widgetAdder", action: EditorTypes_1.TableActionType.AddTable })
            .doAction(function (event, editor) {
            TableActions.addTableWidget(editor, event.data.rows, event.data.columns);
            editorTelemetry.tableAddedInto(blockType);
            return true;
        }),
        onTableDelete: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("deleteTable")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.DeleteTable })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.tableDeleted();
            return true;
        }),
        onTableAddRow: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("addTableRow")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.AddRow })
            .doAction(function (event, editor) {
            TableActions.addTableRow(editor, event.data.path, event.data.row);
            return true;
        }),
        onTableAddRepeatingRow: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("addRepeatingTableRow")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.AddRepeatingRow })
            .doAction(function (event, editor) {
            TableActions.addRepeatingTableRow(editor, event.data.path, event.data.row);
            editorTelemetry.tableRepeatingRowAdded();
            return true;
        }),
        onTableSetRepeatingRowToken: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled(EditorTypes_1.TableActionType.SetRepeatingRowToken)
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: Types_1.WidgetBlockType.Table, action: EditorTypes_1.TableActionType.SetRepeatingRowToken })
            .doAction(function (event, editor) {
            TableActions.setRepeatingTableRowToken(editor, event.data.path, event.data.repeatingToken);
            editorTelemetry.tableRepeatingRowTokenSet(event.data.repeatingToken);
            return true;
        }),
        onTableDeleteRows: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("deleteTableRows")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.DeleteRows })
            .doAction(function (event, editor) {
            TableActions.deleteTableRows(editor, event.data.path, event.data.rows);
            return true;
        }),
        onTableAddColumn: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("addTableColumn")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.AddColumn })
            .doAction(function (event, editor) {
            TableActions.addTableColumn(editor, event.data.path, event.data.column, event.data.columnBorders);
            return true;
        }),
        onTableDeleteColumns: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("deleteTableColumns")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.DeleteColumns })
            .doAction(function (event, editor) {
            TableActions.deleteTableColumns(editor, event.data.path, event.data.columns, event.data.columnBorders);
            return true;
        }),
        onTableResizeColumns: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("resizeTableColumns")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.ResizeColumns })
            .doAction(function (event, editor) {
            TableActions.resizeColumns(editor, event.data.path, event.data.columnBorders);
            return true;
        }),
        onTableSelectionChange: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableSelectionChange")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", action: EditorTypes_1.TableActionType.SelectionChange })
            .doAction(function (event, editor) {
            TableActions.updateSelection(editor, event.data.path, event.data.selection);
            return true;
        }),
        updateAnyTableSelection: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("updateAnyTableSelection")
            .isEvent(EditorTypes_1.EventType.Selection)
            .selectionIsExpanded()
            .doAction(function (event, editor) {
            TableActions.updateTableSelections(editor);
            return false;
        }),
        onTableBackspace: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onTableBackspace")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            TableActions.clearSelectedCells(editor);
            return true;
        }),
        onTableDeleteContent: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onTableDeleteContent")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Delete)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            TableActions.clearSelectedCells(editor);
            return true;
        }),
        onTableCtrlB: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableCtrlB")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.B)
            .withModifier(BehaviourBuilder_1.KeyModifier.CtrlCmd)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            TableActions.toggleMarkOnCells(editor, Text_1.MarkStyle.Bold);
            return true;
        }),
        onTableCtrlI: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableCtrlI")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.I)
            .withModifier(BehaviourBuilder_1.KeyModifier.CtrlCmd)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            TableActions.toggleMarkOnCells(editor, Text_1.MarkStyle.Italic);
            return true;
        }),
        onSelectedTableKeyPress: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableSelectedKeyPress")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Any)
            .inTableDummy()
            .doAction(function (event, editor) {
            if ((0, TableActionUtilities_1.isContentClearingKeyPress)(event)) {
                TableActions.clearAndSetFocusToAnchorCell(editor);
            }
            return false;
        }),
        onSelectedTableKeyPressShift: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableSelectedKeyPressShift")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Any)
            .withModifier(BehaviourBuilder_1.KeyModifier.Shift)
            .inTableDummy()
            .doAction(function (event, editor) {
            if ((0, TableActionUtilities_1.isContentClearingKeyPress)(event)) {
                TableActions.clearAndSetFocusToAnchorCell(editor);
            }
            return false;
        }),
        onTabLastTableCell: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onTabLastTableCell")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Tab)
            .inTableCell()
            .doAction(function (event, editor) {
            if (TableActions.inLastTableCell(editor)) {
                event.preventDefault();
                TableActions.addTableRowAndSelectNextCell(editor);
                return true;
            }
            return false;
        }),
        onReselection: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("tableTextReselection")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "table", eventType: "reselection" })
            .doAction(function (event, editor) {
            slate_react_1.ReactEditor.focus(editor);
            return true;
        }),
        onBackspaceAtStartOfTableCell: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onBackspaceAtStartOfTableCell")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .isOfAncestry(Models_1.BlockType.TableCell)
            .doAction(function (event, editor) {
            if (TableActions.isAtStartOfCell(editor)) {
                event.preventDefault();
                return true;
            }
        }),
        onDeleteAtEndOfTableCell: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("onDeleteAtEndOfTableCell")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Delete)
            .isOfAncestry(Models_1.BlockType.TableCell)
            .doAction(function (event, editor) {
            if (TableActions.isAtEndOfCell(editor)) {
                event.preventDefault();
                return true;
            }
        }),
    };
});
